import React, { useMemo } from 'react';

interface AppProps {
    namespace: string;
    srcRoot: string;
    config?: unknown;
    children?: React.ReactNode;
}

const App: React.FC<AppProps> = ({ namespace, srcRoot, config, children, ...rest }) => {
    const targetConfig = useMemo(() => {
        if (config) return config;
        return children || {};
    }, [config, children]);

    const target = process.env.npm_lifecycle_event;
    const localTest = process.env.NODE_ENV !== 'production' && !window.location.pathname.startsWith(srcRoot);
    const appFileName = target === 'build:full' ? 'app-full.js' : 'app.js';
    const cssFileName = target === 'build:full' ? 'app-full.css' : 'app.css';

    if (localTest) {
        return (
            <script data-react={namespace} data-src={`/${appFileName}`} type="text/json" {...rest}>
                {JSON.stringify(targetConfig)}
            </script>
        );
    }

    return (
        <script
            data-react={namespace}
            data-src={`${srcRoot}/${appFileName}`}
            data-css-src={`${srcRoot}/${cssFileName}`}
            type="text/json"
            {...rest}
        >
            {JSON.stringify(targetConfig)}
        </script>
    );
};

export default App;
